import { render } from "./TextFieldComponent.vue?vue&type=template&id=c53b07fc&scoped=true"
import script from "./TextFieldComponent.vue?vue&type=script&lang=js"
export * from "./TextFieldComponent.vue?vue&type=script&lang=js"

import "./TextFieldComponent.vue?vue&type=style&index=0&id=c53b07fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53b07fc"]])

export default __exports__